/** Shopify CDN: Minification failed

Line 20:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 34:12 Transforming let to the configured target environment ("es5") is not supported yet
Line 43:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 45:12 Transforming let to the configured target environment ("es5") is not supported yet
Line 56:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 57:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 58:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 75:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 86:7 Transforming let to the configured target environment ("es5") is not supported yet
Line 94:8 Transforming let to the configured target environment ("es5") is not supported yet
... and 74 more hidden warnings

**/
// productItemSetup gets called when Boost PFS filter.js rerenders the page and on initial page load
function productItemSetup() {
  var arrayOfProducts = [];
  
  let flickity_options = {
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        dragThreshold: 8,
        resize: true,
        cellSelector: ".Carousel__Cell",
        wrapAround: true,
        imagesLoaded: true
    };
    
   
    function initializeProductTile(element) {
        if (element) {
            let productTile = element;

            initializeCarousels(productTile);
          
            initializeFlickity(productTile);
        }
    }

    function initializeFlickity(productTile) {
        let flickityNode = $(productTile).find(".js-flickity");
        if (flickityNode.length) {
            let flkty = new Flickity(flickityNode[0], flickity_options);
            flkty._getWrapShiftCells();
            flkty.reloadCells();
          $(flickityNode[0]).resize();
           
          
        }
    }
  
  function initializeCarousels(productTile) {
      
        let allProducts = arrayOfProducts;
        let wrapperParent = $(productTile).find(".product-color-swatch")[0];
        let wrapper = $(productTile).find(".swatch-wrapper")[0];
        
        if (!wrapper) {
            buildCarousel(productTile, allProducts);
        }else{
          wrapper.remove();
          buildCarousel(productTile, allProducts);

        }

        initializeCarouselArrows(productTile);
        initializeSwatches(productTile);
        window.setTimeout(function() {
            wrapperParent.className += " fade-in";
        }, 50)
  }
    function initializeCarouselArrows(productTile) {
        let carousel = $(productTile).find(".carousel")[0],
            arrows = $(productTile).find(".slideshow__arrow"),
            leftArrow = $(arrows[0])[0],
            rightArrow = $(arrows[1])[0],
            saleCarousel = $(productTile).find(".sale-carousel")[0];
        connectArrows(carousel, leftArrow, rightArrow);
        if (saleCarousel && arrows.length > 3) {
            connectArrows(saleCarousel, $(arrows[2])[0], $(arrows[3])[0]);
        }
    }
    function initializeSwatches(productTile) {
       let swatches = Array.from($(productTile).find(".swatch"));
        swatches.map((el, index) => {
            $(el).click(() => {
                switchVariant(productTile, { ...el.dataset });
            });
        });
    }
    function initializeQuickAdd(productTile) {
        let allProducts = arrayOfProducts;

        let productId = productTile.id ? productTile.id : productTile.dataset.id,
            newProduct = {};
        for (let i in allProducts) {
            if (allProducts[i].id == productId) {
                newProduct = allProducts[i];

                break;
            }
        }

        var productItemElement = $(productTile).find(".ProductItem")[0];
        // build the HTML for the quick add
        var oldSizeWrapper = $(productTile).find(".ProductSizes__Wrapper");
        // inject the html
        var sizeWrapperParent = $(oldSizeWrapper).parent("a");
        var sizeWrapper = document.createElement("div");


        sizeWrapper.className = "ProductSizes__Wrapper";
        sizeWrapper.id = `product-${newProduct.id}-sizes`;
        let header = document.createElement("h1");
        header.className = "quick-add-header";
        header.textContent = "Add to Bag";
        let options = newProduct.options;
        let optionJSON = [];
        for (let i in options) {
            let newOption = {};
            newOption.name = options[i];
            newOption.values = [];
            for (let k in newProduct.variants) {
                newOption.values.push(newProduct.variants[k].title);
            }
            optionJSON.push(newOption);
        }
        header.setAttribute("data-options", JSON.stringify(optionJSON))

        sizeWrapper.appendChild(header);
        let product_variants = newProduct.variants;
        let soldout = false;
        let numberAvailable = product_variants ? product_variants.length : 1;
        for (let variant in product_variants) {

            if (product_variants[variant].available) {

                let form = document.createElement("form");
                form.method = "post";
                form.action = "/cart/add";
                form.enctype = "multipart/form-data";
                form.id = `product_form_${newProduct.id}`;
                form.className = "shopify-product-form quick-add-size";
                let hiddenInputFormType = document.createElement("input");
                hiddenInputFormType.type = "hidden";
                hiddenInputFormType.name = "form_type";
                hiddenInputFormType.value = "product";
                form.appendChild(hiddenInputFormType);
                let hiddenInputFormat = document.createElement("input");
                hiddenInputFormat.type = "hidden";
                hiddenInputFormat.name = "utf8";
                hiddenInputFormat.value = "✓";
                form.appendChild(hiddenInputFormat);
                let hiddenInputID = document.createElement("input");
                hiddenInputID.type = "hidden";
                hiddenInputID.name = "id";
                hiddenInputID.value = product_variants[variant].id;
                form.appendChild(hiddenInputID);
                let hiddenInputSKU = document.createElement("input");
                hiddenInputSKU.type = "hidden";
                hiddenInputSKU.name = "sku";
                hiddenInputSKU.value = product_variants[variant].sku;
                form.appendChild(hiddenInputSKU);

                let inputSubmit = document.createElement("input");
                inputSubmit.type = "submit";
                inputSubmit.className = "quick_size_button";
                inputSubmit.name = "button";
                inputSubmit.title = product_variants[variant].title;
                inputSubmit.value = product_variants[variant].title;
                form.appendChild(inputSubmit);
                sizeWrapper.appendChild(form);
            } else {
                numberAvailable--;
                let newDiv = document.createElement("div");
                newDiv.className = "quick-add-size quick_size_button not-available";
                let textNode = document.createTextNode(
                    product_variants[variant].title
                );
                newDiv.appendChild(textNode);
                sizeWrapper.appendChild(newDiv);
            }


            $(oldSizeWrapper).remove();
            sizeWrapperParent[0].appendChild(sizeWrapper);
        }
        if (numberAvailable == 0) {
            soldout = true;
        }
        if (soldout) {
            if (!productItemElement.classList.contains("Soldout")) {
                productItemElement.classList.add("Soldout");
            }
            var productLabelList = $(productTile).find(".ProductItem__LabelList");
            var productLabels = Array.from(productLabelList.children());
            if (productLabels.length) {
                for (let i in productLabels) {

                    if (productLabels[i].innerHTML.toLowerCase() == "sale") {
                        productLabels[i].remove();
                    }
                }
            }
            var viewQuickAddButton = $(productTile).find(".view-quick-add")[0];
            viewQuickAddButton.disabled = true;
        } else {
            if (productItemElement.classList.contains("Soldout")) {
                productItemElement.classList.remove("Soldout");
            }
        }
    }

    // Library of functions, they get their elements as arguments
    function checkOverflow(element) {
        let carousels = element ? [element] : $(".carousel");

        for (let i in carousels) {
            let carousel = carousels[i],
                leftArrow = $(carousel).parent().find(".slideshow__arrow")[0],
                rightArrow = $(carousel).parent().find(".slideshow__arrow")[1];
            if (carousel && leftArrow && rightArrow) {
                let max = carousel.scrollWidth;
                let w = $(carousel).innerWidth();
                let current = $(carousel).scrollLeft();
                let atEnd = w + current >= max;
                let nextIsHidden = $(rightArrow).css("visibility") === "hidden";
                let previousIsHidden = $(leftArrow).css("visibility") === "hidden";

                if (atEnd && !nextIsHidden) {
                    $(rightArrow).css("visibility", "hidden");
                }
                if (current == 0 && atEnd) {
                    $(rightArrow).css("visibility", "hidden");

                    $(leftArrow).css("visibility", "hidden");
                }

                if (current == 0 && !previousIsHidden) {
                    $(leftArrow).css("visibility", "hidden");
                }
                if (current == 0 && !atEnd) {
                    $(rightArrow).css("visibility", "visible");
                }
                if (current > 0 && !atEnd) {
                    if (nextIsHidden) {
                        $(rightArrow).css("visibility", "visible");
                    }
                    if (previousIsHidden) {
                        $(leftArrow).css("visibility", "visible");
                    }
                }
            }
        }
    }

    function connectArrows(carousel, leftArrow, rightArrow) {
        if (carousel) {
            $(leftArrow).click((e) => {
                e.preventDefault();
                scrollCarouselLeft(carousel);
            });
            $(rightArrow).click((e) => {
                e.preventDefault();

                scrollCarouselRight(carousel);
            });

            carousel.onscroll = () => {
                checkOverflow(carousel);
            };
        }
    }

    function buildCarousel(productTile, allProducts) {
        let productId = productTile.id ? productTile.id : productTile.dataset.id;
        let newProduct = {};
        for (let i in allProducts) {
            if (allProducts[i].id == productId) {

                newProduct = allProducts[i];
                break;
            }
        }
        var itemInfo = $(productTile).find(".ProductItem__Info")[0];
        var carouselParent = $(productTile).find(".product-color-swatch")[0];
        if (!carouselParent) {
            let newParent = document.createElement("div");
            newParent.className = "product-color-swatch";
            itemInfo.prepend(newParent);
            carouselParent = newParent;
        }
        var swatchGroup = "";
        var colors = [];
        for (let t in newProduct.tags) {
            if (newProduct.tags[t].includes("__swatch group")) {
                swatchGroup = newProduct.tags[t];
                break;
            }
        }
        if (swatchGroup != "") {
            for (let i in allProducts) {
                for (let tag in allProducts[i].tags) {
                    if (allProducts[i].tags[tag] == swatchGroup) {
                        for (let k in allProducts[i].tags) {
                            if (allProducts[i].tags[k].includes("__swatch color")) {
                                let color = allProducts[i].tags[k].split(":").pop();
                                let swatch = {};

                                var url_color = Utils.getFilePath(
                                    Utils.slugify(color),
                                    Globals.swatchExtension,
                                    Settings.getSettingValue("general.swatchImageVersion")
                                );
                                swatch.id = allProducts[i].id;
                                swatch.href = "/products/" + allProducts[i].handle;
                                swatch.src = url_color;
                                swatch.value = color;
                                swatch.title = allProducts[i].title;
                                swatch.images = allProducts[i].images;
                                swatch.price = allProducts[i].price;
                                swatch.compare_at_price = allProducts[i].compare_at_price_max;
                                colors.push(swatch);
                            }
                        }
                    }
                }
            }
        }
        if (colors.length > 0) {
            let hidden = colors.length < 7;
            let wrapper = document.createElement("div");
            wrapper.className = "swatch-wrapper";
            let buttons = document.createElement("div");
            buttons.className = "color-buttons";
            let leftArrow = document.createElement("button");
            leftArrow.style = "visibility: hidden;";
            leftArrow.className = "slideshow__arrow slideshow__arrow-previous";
            leftArrow.setAttribute("aria-label", "Previous slide");
            leftArrow.innerHTML = `<svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18">
          <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
        </svg>`;
            leftArrow.style = "visibility: hidden;";
            let rightArrow = document.createElement("button");

            rightArrow.className = "slideshow__arrow slideshow__arrow-next";
            rightArrow.setAttribute("aria-label", "Next slide");
          
            rightArrow.innerHTML = `<svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18">
          <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
        </svg>`;
            if (hidden) {
                rightArrow.style = "visibility: hidden;";
            } else {
                rightArrow.style = "visibility: visible;";
            }
            buttons.appendChild(leftArrow);
            buttons.appendChild(rightArrow);
            wrapper.appendChild(buttons);
            let colorCarousel = document.createElement("div");
            colorCarousel.className = "color-carousel swatch-colors carousel";
            for (let i in colors) {
                if (colors[i].title === newProduct.title) {
                    let anchor = document.createElement("a");
                    anchor.className = "Slideshow__Cell color_wrapper swatch";
                    anchor.setAttribute("data-id", colors[i].id);
                    anchor.setAttribute("data-url", colors[i].href);

                    anchor.setAttribute("data-images", colors[i].images.toString());
                    anchor.setAttribute("data-title", colors[i].title);
                    anchor.setAttribute("data-value", colors[i].value);

                    anchor.setAttribute("data-price", "$" + colors[i].price / 100);
                    anchor.setAttribute(
                        "data-compare-price",
                        "$" + colors[i].compare_at_price / 100
                    );
                    let colorImg = document.createElement("img");
                    colorImg.src = colors[i].src;
                    colorImg.setAttribute("title", colors[i].title);
                    colorImg.setAttribute("width", "50px");

                    colorImg.classList.add("selected");
                    anchor.appendChild(colorImg);
                    colorCarousel.appendChild(anchor);
                }
            }
            for (let i in colors) {
                if (colors[i].title != newProduct.title) {
                    let anchor = document.createElement("a");
                    anchor.className = "Slideshow__Cell color_wrapper swatch";
                    anchor.setAttribute("data-id", colors[i].id);
                    anchor.setAttribute("data-url", colors[i].href);
                   
                    anchor.setAttribute("data-images", colors[i].images.toString());
                    anchor.setAttribute("data-title", colors[i].title);
                    anchor.setAttribute("data-value", colors[i].value);

                    anchor.setAttribute("data-price", "$" + colors[i].price / 100);
                    anchor.setAttribute(
                        "data-compare-price",
                        "$" + colors[i].compare_at_price / 100
                    );
                    let colorImg = document.createElement("img");
                    colorImg.src = colors[i].src;
                    colorImg.setAttribute("title", colors[i].title);
                    colorImg.setAttribute("width", "50px");

                    colorImg.classList.remove("selected");
                    anchor.appendChild(colorImg);
                    colorCarousel.appendChild(anchor);
                }
            }
            wrapper.appendChild(colorCarousel);
            carouselParent.appendChild(wrapper);
        }
        itemInfo.prepend(carouselParent);
    }

    function switchVariant(productTile, variantData) {
        
        let id = productTile.id ? productTile.id : productTile.dataset.id;

        if (id != variantData.id) {

            let carousel = $(productTile).find(".carousel"),
                swatches = Array.from($(carousel).children()),
                title = $(productTile).find(".ProductItem__Title").children("a")[0],
                priceList = $(productTile).find(".ProductItem__PriceList")[0],
                prices = Array.from($(priceList).children()),
                imageWrapper = $(productTile).find(
                    ".ProductItem__ImageWrapper:not(.ProductImageCarousel)"
                )[0],
                productImageCarouselWrapper = $(productTile).find(
                    ".ProductImageCarousel"
                )[0],
                imageFeature = $(productTile).find(
                    ".ProductItem__Image:not(.ProductItem__Image--alternate)"
                )[0],
                imageAlt = $(productTile).find(
                    ".ProductItem__Image.ProductItem__Image--alternate"
                )[0],
                flickityNode = $(productTile).find(".js-flickity");

            var viewQuickAddButton = $(productTile).find(".view-quick-add")[0];
            viewQuickAddButton.disabled = false;
            var productColorElement = $(productTile).find(".ProductColor")[0];
            var productLabelList = $(productTile).find(".ProductItem__LabelList");
            var productLabels = Array.from(productLabelList.children());
            let price = parseInt(variantData.price.replace("$", ""));
            let comparePrice = parseInt(variantData.comparePrice.replace("$", ""));

            if (comparePrice == 0 || comparePrice == price) {
                if (prices.length > 1) {
                    for (let i in prices) {
                        prices[i].remove();
                    }
                    let newPriceSpan = document.createElement("span");
                    newPriceSpan.classList = "ProductItem__Price Price";
                    newPriceSpan.innerHTML = variantData.price;
                    priceList.appendChild(newPriceSpan);
                } else {
                    prices[0].innerHTML = variantData.price;
                }
            } else {
                if (prices.length > 1) {
                    prices[1].innerHTML = variantData.price;
                } else {
                    prices[0].remove();
                    let newPriceLabel = document.createElement("span");
                    let newPriceSpan = document.createElement("span");
                    let newComparePriceSpan = document.createElement("span");
                    newPriceLabel.classList = "ProductItem__Price Price price-label Price--highlight";
                    newPriceLabel.innerHTML = "Now&nbsp;";
                    newPriceSpan.classList = "ProductItem__Price Price Price--highlight";
                    newPriceSpan.innerHTML = variantData.price;
                    newComparePriceSpan.classList = "ProductItem__Price Price Price--compareAt Text--subdued";
                    newComparePriceSpan.innerHTML = variantData.comparePrice;
                    priceList.appendChild(newPriceLabel);
                    priceList.appendChild(newPriceSpan);
                    priceList.appendChild(newComparePriceSpan);

                }
            }

            if (productLabels.length) {
                for (let i in productLabels) {

                    if (productLabels[i].innerHTML.toLowerCase() == "sale") {
                        if (price == comparePrice || comparePrice == 0) {
                            productLabels[i].remove();
                        }
                    }
                }
            } else if (price < comparePrice) {

                let labelSpan = document.createElement("span");
                labelSpan.className = "ProductItem__Label Heading Text--subdued Price--highlight";
                labelSpan.innerHTML = "Sale";
                productLabelList.append(labelSpan);
            }
            let sliderItems = [...$(flickityNode).find(".Product__SlideItem")];
           
            productColorElement.innerHTML = variantData.value;

            $(flickityNode[0]).flickity(flickity_options);
            let masterNode = sliderItems[0];
            let variantImages = variantData.images.split(",");

            imageWrapper.href = variantData.url;
            title.href = variantData.url;
         
            imageFeature.src = variantImages[0];
            imageFeature.srcset = variantImages[0];
            imageFeature.setAttribute("data-srcset", variantImages[0]);
            imageFeature.setAttribute("data-src", variantImages[0]);

            if (imageAlt) {
                if (variantImages.length > 1) {
                    imageAlt.src = variantImages[1];
                    imageAlt.srcset = variantImages[1];
                    imageAlt.setAttribute("data-srcset", variantImages[1]);
                    imageAlt.setAttribute("data-src", variantImages[1]);


                } else {
                    imageAlt.src = variantImages[0];
                    imageAlt.srcset = variantImages[0];
                    imageAlt.setAttribute("data-srcset", variantImages[0]);
                    imageAlt.setAttribute("data-src", variantImages[0]);

                }

            }


            productImageCarouselWrapper.href = variantData.url;
            for (let i = 0; i < sliderItems.length; i++) {
                $(flickityNode).flickity("remove", sliderItems[i]);
            }
            for (let i = 0; i < variantImages.length; i++) {
                let clonedNode = masterNode.cloneNode(true);
                let imgElement = $(clonedNode).find("img")[0];
                clonedNode.id = "";
                imgElement.src = variantImages[i];
                imgElement.srcset = variantImages[i];
                imgElement.setAttribute("data-srcset", variantImages[i]);
                imgElement.setAttribute("data-src", variantImages[i]);


                $(flickityNode[0]).flickity("append", clonedNode);
            }
            $(flickityNode).flickity("resize");
 
          
            productTile.id = variantData.id;

            
            swatches.map((el, index) => {
                let id = el.id ? el.id : el.dataset.id;
                if (id === variantData.id) {
                    $(el).children("img").addClass("selected");
                } else {
                    $(el).children("img").removeClass("selected");
                }
            });

            // remove the quick-add
            initializeQuickAdd(productTile);
        }
    }

    function scrollCarouselLeft(element) {
        scrollCarousel(element, "-=");
    }
    function scrollCarouselRight(element) {
        scrollCarousel(element, "+=");
    }
    function scrollCarousel(element, operator) {
        let arrows = $(element).parent().find(".slideshow__arrow");
        $(element).animate({ scrollLeft: operator + `${$(element).width()}px` });
        checkOverflow(element, arrows[0], arrows[1]);
    }
   
    function setup() {

        let gridCells = Array.from($(".Grid__Cell:not(.section-block)"));
        if (gridCells.length) {

            gridCells.map(function (el, index) {
                initializeProductTile(el);
            });
        } else {
            initializeCarouselArrows($(".Product"));
        }
    }
    fetch("/pages/all-products").then((response)=>{
        return response.json();
      }).then((data)=>{
      arrayOfProducts = data;
          setup();

      });
        
}

$(document).ready(function () {
    productItemSetup();
});
